<template>
    <div class="container">
        <div class="login" v-if="!forgetpwd">
                <div class="login-title">
                    <span>用户登录</span>
                    <!-- <span>注册</span> -->
                    <router-link tag="span" to="/Register">注册</router-link>
                    <span>没有账号？</span>
                </div>
                <Form ref="formInline_one" :model="formInline_one" :rules="ruleInline_one" autocomplete="off" >
                    <FormItem prop="user">
                        <Input type="text" placeholder="用户名/手机/邮箱地址" style="display:none"/>
                        <Input type="text" v-model="formInline_one.user" @on-change="dynamicpwd($event)"  placeholder="用户名/手机号"/>
                    </FormItem>
                    <FormItem prop="password">
                        <Input type="password" v-model="formInline_one.password" @keyup.enter.native="handleSubmit()" placeholder="密码" />
                    </FormItem>
                     <FormItem prop="status">
                        <!-- <CheckboxGroup @on-change="rememberpwd">
                            <Checkbox v-model="single" label="记住密码"></Checkbox>
                        </CheckboxGroup> -->
                        <Checkbox v-model="single" @on-change="rememberpwd" >记住密码</Checkbox>
                        <span class="forget" @click="forgetpwds">忘记密码</span>
                    </FormItem>
                    <FormItem>
                        <Button type="primary" @click="handleSubmit()" class="sub">登录</Button>
                    </FormItem>
            </Form>
        </div>
         <div class="login" v-if="forgetpwd">
                <div class="login-title">
                    <span>重置密码</span>
                     <span @click="backLogin">登录</span>
                     <!-- <router-link tag="span" to="/Login">登录</router-link> -->
                    <span>已有账号？</span>
                </div>
                <Form ref="formInline_two" :model="formInline_two" :rules="ruleInline_two" >
                    <FormItem prop="phone">
                        <Input type="text" placeholder="Username" style="display:none"/>
                        <Input type="text" v-model="formInline_two.phone"  placeholder="请输入您的手机号码或邮箱地址" />
                    </FormItem>
                    <FormItem prop="password">
                        <Input type="password" v-model="formInline_two.new_password" placeholder="请输入新的密码" />
                    </FormItem>
                     <FormItem prop="verification">
                         <Row>
                            <Input type="text" class="phonenum" v-model="formInline_two.code"  placeholder="请输入您的验证码" />
                            <Button class="getnum" @click="getverification()" v-if="showcode">验证码</Button>
                            <Button class="getnum" v-if="!showcode">{{count}}S</Button>
                        </Row>
                    </FormItem>
                    <FormItem>
                        <Button type="primary"  @click="handleRepeat"  class="sub">提交</Button>
                    </FormItem>
                </Form>
        </div>
    </div>
</template>


<script>
import Cookies from "js-cookie"
import doPost from "@/pages/Helper/XHR.js"
export default {
    data () {
        return {
            forgetpwd: false,
            single: Cookies.get(`single`) ? true : false,
            accountName: '',
            count: '',
            showcode: true,
            //登录
            formInline_one: {
                user: '',
                password: '',
            },
            //重置
            formInline_two: {
                phone: '',
                code: '',
                new_password: '',
                new_password_cf: ''
            },
            //登录规则
            ruleInline_one: {
                user: [
                    { required: true, message: '请输入您的用户名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入您的密码', trigger: 'blur' },
                    { type: 'string', min: 6, message: '密码不能小于6位', trigger: 'blur' }
                ]
            },
            //重置规则
            ruleInline_two: {
                phone: [
                    { required: true, message: '请输入您的账号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入您的新密码', trigger: 'blur' },
                    { type: 'string', min: 3, message: '密码不能小于3位', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        dynamicpwd (data) {
          if(Cookies.get('single')){
              if(data != Cookies.get('User')){
                this.formInline_one.password = ''
              }
          }
        },
        // 登录提交
        handleSubmit(name) {
            this.$Loading.start()
            if(this.formInline_one.user == '' || this.formInline_one.password == ''){
                this.$Message.error('登录失败!')
                this.$Loading.error()
                return
            }
            doPost(
                {action: "user_login", username: this.formInline_one.user, password: this.formInline_one.password, dev: 'dnf'},
                (data) => {
                    if(!data.status){
                        this.$Loading.finish()
                        if(!data.session){
                          this.$Message.error('登录失败!')
                          this.$router.push('/')
                        }
                        this.$store.commit('changeLogin',true)
                        this.$Message.success(`${data.detail}`)
                        // localStorage.setItem("session",data.session)
                        Cookies.set("session",data.session)
                        localStorage.LoginStatus = true
                         // 截取服务端返回的session字段中的用户名 存进cookie 待用户到达购买页面 将自动帮其输入用户名
                        Cookies.set("username",data.session.split('--')[0])

                        // Cookies.set("username",this.formInline_one.user)
                        // localStorage.setItem("username",this.formInline_one.user)
                        if(this.single){
                          this.rememberpwd()
                        }
                        this.repeatData()
                        this.$router.push("/Personal")
                    }else{
                        this.$Loading.error()
                        this.$Message.error(`${data.detail}`)
                    }
                  }

            )

        },
        repeatData () {
          this.formInline_one.user = ''
          this.formInline_one.password = ''
          this.formInline_two.user = ''
          this.formInline_two.password = ''
        },
        // 重置提交
        handleRepeat () {
            doPost(
                {
                  action: "forget_pwd",
                  phone: this.formInline_two.phone,
                  code: this.formInline_two.code,
                  new_password: this.formInline_two.new_password,
                  new_password_cf: this.formInline_two.new_password,
                },
                (data) => {
                    this.$Message.success(data.detail)
                    setTimeout(() => {
                        this.backLogin()
                    },2000)
                }
            )
        },
        getverification () {
            doPost(
                {action: "send", phone: this.formInline_two.phone, tag: "1"},
                (data) => {
                    this.$Message.success(data.detail)
                    if(!data.status){
                        this.getCode()
                    }
                    // if(!data.status){
                    //     this.$store.commit('changeLogin',true)
                    //     this.$Message.success('登录成功!')
                    // }else{
                    //     this.$Message.error('登录失败!')
                    // }
                }
            )
        },
        // 记住密码
        rememberpwd () {
            // console.log(this.formInline_one.user,this.formInline_one.password)
            // console.log(this.single)
            if(this.single){
                // localStorage.setItem(`single`,true)
                // localStorage.setItem(`User`, this.formInline_one.user)
                // localStorage.setItem(`Password`, this.formInline_one.password)
                Cookies.set('single', true)
                Cookies.set('User', this.formInline_one.user)
                Cookies.set('Password', this.formInline_one.password)
            }else{

                // localStorage.removeItem(`single`)
                // localStorage.removeItem(`User`)
                // localStorage.removeItem(`Password`)
                Cookies.remove('single')
                Cookies.remove('User')
                Cookies.remove('Password')
            }
        },
        forgetpwds () {
            this.forgetpwd = true
        },
        backLogin () {
            this.forgetpwd = false
        },
        // 60s倒计时
        getCode () {
            const TIME_COUNT = 60
            if(!this.timer){
                this.count = TIME_COUNT
                this.showcode = false
                this.timer = window.setInterval( ()=> {
                    if(this.count > 0 && this.count <= 60) {
                        this.count --
                    } else{
                        this.showcode = true
                        clearInterval(this.timer)
                        this.timer = null
                    }
                },1000)
            }
        }
    },
    mounted () {
        if(Cookies.get('single')){
            // this.formInline_one.user = localStorage.getItem(`User`)
            // this.formInline_one.password = localStorage.getItem(`Password`)
            this.formInline_one.user = Cookies.get('User')
            this.formInline_one.password = Cookies.get('Password')
        }else{
            this.formInline_one.user = ''
            this.formInline_one.password = ''
        }
    }
}
</script>

<style lang="stylus" scoped>
    .container
        position relative
        background-image url("~@/assets/img/login_img/0.0bg.png")
        background-size 100% 100%
        &:after
            content ''
            display block
            height 783px
            clear both
    .login
        margin 0 auto
        width 382px
        height 375px
        position absolute
        top 50%
        left 62%
        margin-left -1rem
        margin-top -4rem
        z-index 11
        background #fff
    .login-title
        height 1rem
        padding 1rem
    .login-title span:nth-child(1)
        font-size .4rem
        float left
    .login-title span:nth-child(2)
        float right
        color #2BD3A0
    .login-title span:nth-child(3)
        float right
    >>> .ivu-checkbox-default
        display inline-block
    >>>.ivu-form
        padding 0rem 1rem
    >>> .ivu-input-wrapper input
        height .86rem
        &::focus
          border 1px solid #000
    >>> .ivu-btn-primary
        border-color #2dd39f
    .phonenum
        display inline-block
        width 70%
    >>> .getnum
        width 28%
        height .86rem
    .sub
        width 100%
        height .86rem
        font-size .35rem
        background #2BD3A0
        margin-top 10px
    .forget
        float right
    @media (min-width: 900px) and (max-width: 1480px)
        .login
            left 60%
            width 8rem
    @media (min-width: 768px) and (max-width: 900px)
         .login
            left 60%
            width 6.2rem
            height 7rem
    @media screen and (max-width: 768px)
        .container
            height 10rem
        .login
            left 50%
            width 6.2rem
            height 7rem
            margin-left -3.1rem
    @media screen and (max-width: 458px)
        .container,.login
            position static
        .container
            height auto
            position fixed
            width 100%
        .login
            left 0
            margin-left 0
            height auto
            margin-top 0rem
            position relative
            width 100%
            height 100%
        .container:after
            height 0rem
         >>>.ivu-form
            padding 0 .1rem
        >>>.ivu-input:link, .ivu-input:visited, .ivu-input:hover
            border-color #2bd3a0
</style>




// WEBPACK FOOTER //
// src/pages/Auth/Login.vue